var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { DialogRoute, mergeQueryString, updateSearch } from 'bernie-core';
import { Layer } from 'bernie-view';
import { UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { UitkSheetTransition } from 'uitk-react-sheet';
import { UitkSpacing } from 'uitk-react-spacing';
import { parse } from 'query-string';
import { ActivitySort } from '../../../common/__generated__/api';
import { PrimaryButtonTracked, TertiaryButtonTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';
import { getFilteredObjectKeys, getPageId } from '../../../helpers/common-helper';
import { getUpdatedFilterQueryObject } from './filter-helper';
import { SortFilter } from './sort-filter';
import { SortFilterDialogButton } from './sort-filter-dialog-button';
export var SortFilterDialog = function (_a) {
  var _b, _c, _d, _e, _f, _g;
  var loading = _a.loading;
  var _h = useStores(),
    analytics = _h.analytics,
    activitySearchStore = _h.activitySearchStore,
    searchCriteriaStore = _h.searchCriteriaStore;
  var history = useHistory();
  var location = useLocation();
  var pageId = getPageId(activitySearchStore);
  var focusField = React.useRef();
  var _j = activitySearchStore.universalSortAndFilter || {},
    toolbar = _j.toolbar,
    applyAction = _j.applyAction;
  var _k = (toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions) || {},
    primary = _k.primary,
    secondaries = _k.secondaries;
  var handleSortAndFilterDialogClose = function () {
    updateSearch({
      history: history,
      location: location,
      newParams: {
        pwaDialog: ''
      }
    });
  };
  var createQueryString = function (filterKeys, pwaDialog) {
    return mergeQueryString(location.search, __assign({
      sort: activitySearchStore.sortAndFilterObject.initialSelectedSort,
      slimSearchKeyword: activitySearchStore.sortAndFilterObject.keywordValue,
      pwaDialog: pwaDialog
    }, getUpdatedFilterQueryObject(activitySearchStore)));
  };
  var handleClick = function (event) {
    event.preventDefault();
    var queryParams = parse(location.search);
    var isQueryKeysDifferent = searchCriteriaStore.isQueryKeysDifferent(queryParams);
    if (isQueryKeysDifferent) {
      activitySearchStore.searchSetup();
    }
    var filterKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters);
    var newQueryString = createQueryString(filterKeys, '');
    if (activitySearchStore.sortAndFilterObject.keywordValue.length > 0) {
      analytics.trackEvent("".concat(pageId, ".filterSort.SearchActivity"), 'keyword-search-done', analytics.omnitureData, null, true);
    }
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  };
  var clearForm = function () {
    activitySearchStore.sortAndFilterObject.initialSelectedSort = ActivitySort.RECOMMENDED;
    activitySearchStore.sortAndFilterObject.keywordValue = '';
    var filterCategoryKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters);
    filterCategoryKeys.forEach(function (filterCategoryKey) {
      var filterKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[filterCategoryKey]);
      filterKeys.forEach(function (filterKey) {
        return activitySearchStore.sortAndFilterObject.filters[filterCategoryKey][filterKey].selected = false;
      });
    });
    activitySearchStore.sortAndFilterObject.initialSeeAllOption = false;
    var newQueryString = createQueryString(filterCategoryKeys, 'filter');
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  };
  return React.createElement("fieldset", {
    disabled: loading,
    "aria-busy": loading,
    ref: focusField,
    "data-testid": "sort-filter-dialog--fieldset"
  }, React.createElement(DialogRoute, {
    id: "filter"
  }, React.createElement(UitkSheetTransition, {
    isVisible: true
  }, React.createElement(Layer, {
    id: "dialog-filter"
  }, React.createElement(UitkFullscreenDialog, {
    "data-testid": "sort-filter-dialog--fullscreen",
    closeCallback: handleSortAndFilterDialogClose,
    dialogShow: true,
    strictFullscreen: true,
    returnFocusOnClose: true
  }, React.createElement(UitkToolbar, {
    toolbarTitle: toolbar === null || toolbar === void 0 ? void 0 : toolbar.primary,
    navigationContent: {
      navType: 'close',
      onClick: function () {
        return handleSortAndFilterDialogClose();
      },
      navButtonId: 'sort-filter-dialog--toolbar',
      navIconLabel: primary === null || primary === void 0 ? void 0 : primary.accessibility
    },
    toolbarActionContent: React.createElement(TertiaryButtonTracked, {
      key: "sort-filter-dialog-clear-button",
      type: "reset",
      onClick: clearForm,
      rfrr: secondaries && ((_c = (_b = secondaries[0]) === null || _b === void 0 ? void 0 : _b.action) === null || _c === void 0 ? void 0 : _c.analytics.referrerId),
      linkName: secondaries && ((_e = (_d = secondaries[0]) === null || _d === void 0 ? void 0 : _d.action) === null || _e === void 0 ? void 0 : _e.analytics.linkName),
      "data-testid": "sort-filter-dialog--clear-button",
      "aria-label": secondaries && ((_f = secondaries[0]) === null || _f === void 0 ? void 0 : _f.accessibility)
    }, secondaries && ((_g = secondaries[0]) === null || _g === void 0 ? void 0 : _g.primary))
  }), React.createElement(UitkSpacing, {
    margin: {
      blockend: 'twelve'
    }
  }, React.createElement(UitkDialogContent, {
    key: "sort-filter-dialog-content"
  }, React.createElement(SortFilter, {
    inDialog: true
  }))), React.createElement(UitkScrim, {
    key: "sort-filter-dialog-scrim",
    type: UitkScrimType.BUTTON
  }, React.createElement(PrimaryButtonTracked, {
    "data-testid": "sort-filter-dialog--done-button",
    linkName: applyAction === null || applyAction === void 0 ? void 0 : applyAction.action.analytics.linkName,
    rfrr: applyAction === null || applyAction === void 0 ? void 0 : applyAction.action.analytics.referrerId,
    type: "button",
    onClick: handleClick,
    isFullWidth: true,
    "aria-label": applyAction === null || applyAction === void 0 ? void 0 : applyAction.accessibility
  }, applyAction === null || applyAction === void 0 ? void 0 : applyAction.primary)))))), React.createElement(SortFilterDialogButton, {
    pageId: pageId
  }));
};